import { DjangoTimeStamped, TimeStamped } from '../django';
import { parseDate } from './../helpers/date';

export class Address implements TimeStamped {
  city: string;
  complement?: string;
  id?: string;
  neighborhood?: string;
  number: string;
  postalCode: string;
  publicPlace: string;
  state: string;
  // DJANGO TIMESTAMPED
  created: Date;
  modified: Date;

  constructor(data: string | Address | DjangoAddress = {}) {
    if (data instanceof Address) {
      bindAddress(this, data);
    } else if (typeof data === 'string') {
      bindDjangoAddressData(this, { id: data });
    } else {
      bindDjangoAddressData(this, data);
    }
  }

  get djangoModel() {
    return getDjangoModel(this);
  }

  get basicInfoFilled() {
    return !!this.city && !!this.number && !!this.postalCode && !!this.publicPlace && !!this.state;
  }
}

export function parseAddress(data?: string | Address | DjangoAddress) {
  if (data) {
    return new Address(data);
  } else {
    return undefined;
  }
}

function bindAddress(address: Address, data: Address) {
  address.city = data.city;
  address.complement = data.complement;
  address.id = data.id;
  address.neighborhood = data.neighborhood;
  address.number = data.number;
  address.postalCode = data.postalCode;
  address.publicPlace = data.publicPlace;
  address.state = data.state;
  // DJANGO TIMESTAMPED
  address.created = data.created;
  address.modified = data.modified;
}

//////////////////////
/// DJANGO SUPPORT ///
//////////////////////
export interface DjangoAddress extends DjangoTimeStamped {
  city?: string;
  complement?: string;
  id?: string;
  neighborhood?: string;
  number?: string;
  postal_code?: string;
  public_place?: string;
  state?: string;
  // DJANGO TIMESTAMPED
  created?: string;
  modified?: string;
}

function bindDjangoAddressData(address: Address, data: DjangoAddress) {
  address.city = data.city;
  address.complement = data.complement;
  address.id = data.id;
  address.neighborhood = data.neighborhood;
  address.number = data.number;
  address.postalCode = data.postal_code;
  address.publicPlace = data.public_place;
  address.state = data.state;
  // DJANGO TIMESTAMPED
  address.created = parseDate(data.created);
  address.modified = parseDate(data.modified);
}

function getDjangoModel(address: Address) {
  return {
    city: address.city,
    complement: address.complement,
    id: address.id,
    neighborhood: address.neighborhood,
    number: address.number,
    postal_code: address.postalCode,
    public_place: address.publicPlace,
    state: address.state,
  };
}
